import axios from 'axios';
import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'
import focus from '@alpinejs/focus'

import ':/pages/general'
import ':/pages/homepage'
import ':/pages/login'
import ':/pages/product-details'
import ':/pages/checkout'
import ':/pages/account'

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

Alpine.plugin(collapse)
Alpine.plugin(focus)
Alpine.start();
